import { jsx as _jsx } from "react/jsx-runtime";
import styled, { keyframes, css } from 'styled-components';
export const Skeleton = (props) => {
    const { className, height = 20, width = '100%', variant = 'rectangle', paddingBlock = 0, } = props;
    const cssVars = {
        '--padding-block': typeof paddingBlock === 'number' ? `${paddingBlock}px` : paddingBlock,
    };
    return (_jsx(Root, { style: { ...cssVars, width, height }, className: className, children: _jsx(Inner, { "$static": props.static ?? false, "$variant": variant }) }));
};
const Keyframes = keyframes `
0% {
    transform: translateX(-100%);
  }
50% {
    transform: translateX(100%);
  }
100% {
    transform: translateX(100%);
  }
`;
const Root = styled.div `
  overflow: hidden;
  padding-block: var(--padding-block, 0);
`;
const Inner = styled.div `
  position: relative;
  background: rgba(var(--background-11-rgb), 0.13);
  overflow: hidden;
  border-radius: ${({ $variant }) => ($variant === 'circular' ? '50%' : '4px')};
  width: 100%;
  height: 100%;

  &:after {
    animation: ${(props) => props.$static
    ? 'none'
    : css `1.5s linear 0.2s infinite normal none running ${Keyframes}`};
    background: linear-gradient(
      90deg,
      transparent,
      rgba(var(--background-12-rgb), 0.13),
      transparent
    );
    content: '';
    position: absolute;
    transform: translateX(-100%);
    inset: 0px;
  }
`;
//# sourceMappingURL=skeleton.js.map